import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env } from "@/env";

// Lazy singleton — deferred until first call so @supabase/supabase-js
// is not instantiated at module-evaluation time (finding #2 bundle fix).
let _client: SupabaseClient | undefined;

export function getSupabase(): SupabaseClient {
  if (!_client) {
    _client = createClient(env.NEXT_PUBLIC_SUPABASE_URL, env.NEXT_PUBLIC_SUPABASE_ANON_KEY, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    });
  }
  return _client;
}
